import * as React from 'react'
import { GatsbyLinkProps } from 'gatsby-link'
import HeaderMenu from './HeaderMenu'
import SidebarMenu from './SidebarMenu'
import { Sidebar, Segment } from 'semantic-ui-react'
import { Link } from 'gatsby'

export interface MenuItem {
  name: string
  path: string
  exact: boolean
  icon?: string
  inverted?: boolean
}

export const menuItems: MenuItem[] = [
  { name: 'O Escritório', path: '/#office', exact: true, icon: 'home', inverted: true },
  { name: 'Projetos', path: '/#projects', exact: true, icon: 'info circle' },
  { name: 'Clientes', path: '/#clients', exact: false, icon: 'newspaper' },
  { name: 'Contato', path: '/#contact', exact: false, icon: 'newspaper' },
]

export interface MenuProps extends React.HTMLProps<HTMLDivElement> {
  items: MenuItem[]
  pathname: string
  Link: React.ComponentClass<GatsbyLinkProps<any>> | any
}

export interface ResponsiveMenuProps {
  children: any
  pathname: string
}

export default ({children, pathname}: ResponsiveMenuProps) => {
  return <>
  <HeaderMenu
    Link={Link} pathname={pathname} items={menuItems} inverted
  />
  <SidebarMenu Link={Link} pathname={pathname} items={menuItems} />
  <Sidebar.Pushable as={Segment}>

    <Sidebar.Pusher style={{ minHeight: '100vh' }}>
      {children}
    </Sidebar.Pusher>
  </Sidebar.Pushable>
</>
}
